// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"306e53e3","239":"5491b2ce","455":"4c6b12f0","488":"564aa5f8"}[chunkId] + ".chunk.js";
};